export default "__VITE_ASSET__DHoc0_go__"